import "@patternfly/patternfly/patternfly-addons.css";
import "@patternfly/react-core/dist/styles/base.css";
import "../public/layout.css";

import { StrictMode} from "react";
import { createRoot } from "react-dom/client";
import { i18n } from "./i18n";
import { KeycloakProviderWithDonorService } from "./context";
import { Root } from "./root/Root";

// Initialize required components before rendering app.
i18n.init().then(() => {
    const container = document.getElementById("app") as HTMLElement;
    const root = createRoot(container);

    root.render(
        <StrictMode>
            <KeycloakProviderWithDonorService>
                <Root />
            </KeycloakProviderWithDonorService>
        </StrictMode>,
    );
});
